import { unreachable } from '@/std/util';

/** Tipo de transferência bancária */
export enum FornecedorTransferenciaTipo {
    Desconhecido = 0,
    Nenhum = 1,
    Pix = 2,
    Ted = 3,
}

/** Tipo da conta bancária: */
export enum FornecedorContaTipo {
    Desconhecido = 0,
    Corrente = 1,
    Poupanca = 2,
}

/** Caso for_transferencia_tipo = 2, este campo indicará o tipo de chave PIX que será utilizada para transferência: */
export enum FornecedorPixChaveTipo {
    Desconhecido = 0,
    Telefone = 1,
    Email = 2,
    CPFCNPJ = 3,
    ChaveAleatoria = 4,
    DadosBancarios = 5,
}

export function getFornecedorPixChaveTipoString(value: FornecedorPixChaveTipo): string {
    switch (value) {
        case FornecedorPixChaveTipo.Desconhecido:
            return 'Desconhecido';
        case FornecedorPixChaveTipo.Telefone:
            return 'Telefone';
        case FornecedorPixChaveTipo.Email:
            return 'Email';
        case FornecedorPixChaveTipo.CPFCNPJ:
            return 'CPF/CNPJ';
        case FornecedorPixChaveTipo.ChaveAleatoria:
            return 'Chave Aleatória';
        case FornecedorPixChaveTipo.DadosBancarios:
            return 'Dados Bancários';
        default:
            unreachable(value);
    }
}

export enum FornecedorTipo {
    IndustriaFabricante = 1,
    Distribuidora = 2,
    Atacadista = 3,
    Varejista = 4,
    ProdutorRural = 5,
    PrestadorServico = 6,
    TransportadoraLogistica = 7,
    RepresentanteComercial = 8,
    Outro = 99,
}
